<template>
    <v-card variant="outlined" class="section-card">
        <div class="section-card-header">
            <v-avatar size="34" color="#fef3c7" class="section-icon">
                <v-icon color="#d97706">mdi-lock-reset</v-icon>
            </v-avatar>
            <div>
                <h2 class="section-title">Mot de passe</h2>
                <p class="section-subtitle">
                    {{ resetPassword ? "Réinitialiser le mot de passe de l'utilisateur" : 'Changer votre mot de passe' }}
                </p>
            </div>
        </div>

        <v-divider></v-divider>

        <div class="section-card-body">
            <v-form @submit.prevent="submit">
                <v-row>
                    <v-col v-if="!resetPassword" cols="12" md="4">
                        <v-text-field
                            density="compact"
                            variant="outlined"
                            clearable
                            type="password"
                            label="Mot de passe actuel"
                            v-model="fields.current_password"
                            :error-messages="errors.current_password"
                        />
                    </v-col>

                    <v-col cols="12" md="4">
                        <v-text-field
                            density="compact"
                            variant="outlined"
                            clearable
                            type="password"
                            label="Nouveau mot de passe"
                            v-model="fields.password"
                            :error-messages="errors.password"
                        />
                    </v-col>

                    <v-col cols="12" md="4">
                        <v-text-field
                            density="compact"
                            variant="outlined"
                            clearable
                            type="password"
                            label="Confirmation"
                            v-model="fields.password_confirmation"
                            :error-messages="errors.password_confirmation"
                        />
                    </v-col>
                </v-row>

                <v-btn theme="dark" type="submit" color="#4f46e5" class="submit-button" :loading="isLoading">
                    <v-icon start>mdi-lock-check-outline</v-icon> Mettre à jour
                </v-btn>
            </v-form>
        </div>
    </v-card>
</template>

<script>
export default {
    name: 'UserPassword',
    props: {
        userId: { required: true },
        resetPassword: { type: Boolean, default: false },
        isLoading: { type: Boolean, required: true }
    },
    data() {
        return {
            fields: {
                current_password: '',
                password: '',
                password_confirmation: ''
            },
            errors: {
                current_password: '',
                password: '',
                password_confirmation: ''
            }
        };
    },
    computed: {
        passwordURL() {
            return this.resetPassword ? `users/${this.userId}/reset-password` : `users/${this.userId}/update-password`;
        }
    },
    methods: {
        submit() {
            this.$emit('load', true);
            axios
                .patch(this.passwordURL, this.fields)
                .then((response) => {
                    if (response.data.success == true) {
                        this.fields = {
                            current_password: '',
                            password: '',
                            password_confirmation: ''
                        };
                        this.errors = {
                            current_password: '',
                            password: '',
                            password_confirmation: ''
                        };
                        this.$emit('onSuccess');
                        this.$swal({
                            icon: 'success',
                            title: 'Opération réussie',
                            text: response.data.message
                        });
                    } else {
                        this.$swal({
                            icon: 'warning',
                            title: 'Erreur !',
                            text: response.data.message
                        });
                    }
                })
                .catch((error) => {
                    this.$swal({
                        icon: 'error',
                        title: 'Erreur !',
                        text: error.message
                    });
                    if (error.errors != undefined) {
                        Object.keys(error.errors).forEach((key) => {
                            this.errors[key] = error.errors[key][0];
                        });
                    }
                })
                .finally(() => {
                    this.$emit('load', false);
                });
        }
    }
};
</script>

<style scoped>
.section-card {
    border-radius: 12px;
}
.section-card-header {
    align-items: center;
    display: flex;
    gap: 16px;
    padding: 12px 16px;
}
.section-title {
    font-size: 0.95rem;
    font-weight: 700;
    line-height: 1.3;
    margin: 0;
}
.section-subtitle {
    color: #64748b;
    font-size: 0.85rem;
    margin: 2px 0 0;
}
.section-card-body {
    padding: 16px;
}
.submit-button {
    border-radius: 8px;
    box-shadow: none;
    height: 38px;
    padding: 0 24px;
    text-transform: none;
}
</style>
